import { api } from './client';
import type { QuoteResponse, QuotesListResponse, QuoteResponseItem } from '../../types/quotes';

export const quotesApi = {
  createQuote(formData: FormData): Promise<QuoteResponse> {
    return api.request<QuoteResponse>('/cargo_quote_requests', {
      method: 'POST',
      body: formData
    });
  },

  getQuotes(filters: Record<string, string> = {}): Promise<QuotesListResponse> {
    const params = new URLSearchParams(filters);
    return api.request<QuotesListResponse>(`/cargo_quote_requests?${params}`);
  },

  getQuote(id: number | string): Promise<QuoteResponse> {
    return api.request<QuoteResponse>(`/cargo_quote_requests/${id}`);
  },

  getQuoteByTracking(trackingNumber: string): Promise<QuoteResponse> {
    return api.request<QuoteResponse>(`/cargo_quote_requests/tracking/${trackingNumber}`);
  },

  deleteQuote(id: number | string): Promise<{ message: string }> {
    return api.request<{ message: string }>(`/cargo_quote_requests/${id}`, {
      method: 'DELETE'
    });
  },

  contactCarrier(quoteId: number | string, quoteResponseId: number | string): Promise<{ message: string; quote_response: QuoteResponseItem; cargo_quote_request: { status: string } }> {
    return api.request<{ message: string; quote_response: QuoteResponseItem; cargo_quote_request: { status: string } }>(`/cargo_quote_requests/${quoteId}/contact_carrier`, {
      method: 'POST',
      body: { quote_response_id: quoteResponseId } as any
    });
  },

  downloadProposalPdf(quoteId: number, responseId: number): Promise<Blob> {
    const token = api.getToken();
    return fetch(
      `${api.baseURL}/cargo_quote_requests/${quoteId}/quote_responses/${responseId}/download_proposal`,
      {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    ).then(response => {
      if (!response.ok) {
        // Throw a stable i18n key so the caller can localize the message.
        throw new Error('quote.detail.toasts.download_pdf_failed');
      }
      return response.blob();
    });
  },
};